const rotate = {
    name: "rotate",
    path: "/rotate",
    title: "rotate",
    description: "Utilities for controlling rotation transforms.",
    value: {
        "rotate": {
            "rotate-none": "none",
            "rotate-<number>": "<number>deg",
            "-rotate-<number>": "calc(<number>deg * -1)",
            "rotate-[<value>]": "<value>",
            "rotate-x-<number>": "rotateX(<number>deg)",
            "-rotate-x-<number>": "rotateX(-<number>deg)",
            "rotate-y-<number>": "rotateY(<number>deg)",
            "-rotate-y-<number>": "rotateY(-<number>deg)",
            "rotate-z-<number>": "rotateZ(<number>deg)",
            "-rotate-z-<number>": "rotateZ(-<number>deg)",
        }
    },
    exampleData: [
        {
            example: {
                code: `<img class="rotate-45 ..." src="/img/mountains.jpg" />
<img class="rotate-90 ..." src="/img/mountains.jpg" />
<img class="rotate-210 ..." src="/img/mountains.jpg" />`
            }
        },
        {
            example: {
                code: `<img class="-rotate-45 ..." src="/img/mountains.jpg" />
<img class="-rotate-90 ..." src="/img/mountains.jpg" />
<img class="-rotate-210 ..." src="/img/mountains.jpg" />`
            }
        },
        {
            example: {
                code: `<img class="rotate-x-50 rotate-z-45 ..." src="/img/mountains.jpg" />
<img class="rotate-x-15 -rotate-y-30 ..." src="/img/mountains.jpg" />
<img class="rotate-y-25 rotate-z-30 ..." src="/img/mountains.jpg" />`
            }
        }
    ],
    htmlData: [
        
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">rotate-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">rotate-45</code> and <code class="text-color-blue-500">rotate-90</code> to rotate an element by degrees:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">rotate-45</span>
          <div class="relative">
            <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-45 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
          </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">rotate-90</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-90 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">rotate-[210deg]</span>
          <div class="relative">
           <div class="absolute inset-0">
                <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-[210deg] size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
    `
        },
        {
            title: "Using negative values",
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">-rotate-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">-rotate-45</code> and <code class="text-color-blue-500">-rotate-90</code> to rotate an element counterclockwise by degrees:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-rotate-45</span>
            <div class="relative">
              <div class="absolute inset-0">
                  <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
              </div>
              <img class="-rotate-45 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
            </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-rotate-90</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-rotate-90 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">-rotate-210</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-rotate-210 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
    `
        },
        {
            title: "Rotating in 3D space",
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">rotate-x-<var>&lt;number&gt;</var></code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">rotate-y-<var>&lt;number&gt;</var></code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">rotate-z-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">rotate-x-50</code>, <code class="text-color-blue-500">-rotate-y-30</code>, and <code class="text-color-blue-500">rotate-z-45</code> together to rotate an element in 3D space:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">rotate-x-50<br/>rotate-z-45</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-x-50 rotate-z-45 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">rotate-x-15<br/>-rotate-y-30</span>
        <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="rotate-x-15 -rotate-y-30 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-10 text-xs text-color-gray-500">rotate-y-25<br/>rotate-z-30</span>
          <img class="rotate-y-25 rotate-z-30 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
        </div>
      </div>
    `
        },
    ],
};

export default rotate;
<div className="rotate-45 rotate-90 rotate-210 rotate-[210deg] opacity-25 -rotate-45 -rotate-90 -rotate-210 rotate-x-50 rotate-z-45 rotate-x-15 -rotate-y-30 rotate-y-25 rotate-z-30"></div>